"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALID_SCAN_EXTENSIONS = void 0;
exports.isValidScanFileType = isValidScanFileType;
const file_utils_1 = require("./file-utils");
exports.VALID_SCAN_EXTENSIONS = ['.ply', '.e57', '.pcd', '.npy', '.npz'];
function isValidScanFileType(filename) {
    const name = filename.toLowerCase();
    const extension = (0, file_utils_1.getFileExtension)(name);
    return exports.VALID_SCAN_EXTENSIONS.includes(extension);
}
//# sourceMappingURL=is-valid-scan-file-type.js.map